/**
* @ngdoc directive
* @name Search
*
* @description
  Search with tags to filter data using ng-tags-input
  row search on desktop
  full screen search on desktop
  used as wrapper for tags-input directive
  http://mbenford.github.io/ngTagsInput/documentation/api
*
* @scope
* @param {Array} tags - list of tags selected
* @param {Function} onTagRemoved - callback called when user clears all tags
*
* @transclude put tags-input directive
*
* @example
  <div ng-init='tags=[]' style='height: 50px'>
  <search tags="tags">
    <tags-input
      ng-model="tags"
      replace-spaces-with-dashes="false"
      min-length="1"
      placeholder="{{'    '}}"
      >

      <auto-complete
        source="getTagsByQuery($query)"
        select-first-match="false"
        min-length="1"
        >
      </auto-complete>
    </tags-input>
  </search>
  </div>
*/

(function () {
  app.directive('search', ["$timeout", "PATH", "screenSizeService", "overflowHiddenService", function ($timeout, PATH, screenSizeService, overflowHiddenService) {
    return {
      replace: true,
      transclude: true,
      scope: {
        tags: '=',
        onTagRemoved: '&',
        reportType: '=?'
      },
      restrict: 'E',
      link: link,
      templateUrl: PATH.components + 'search/template.html'
    };

    function link($scope, $element) {
      var isMobile = screenSizeService.smallerThan('sm');

      $scope.isSearchVisible = isMobile ? false : $scope.tags && $scope.tags.length;
      $scope.showSearch = function () {
        if ($scope.isHiding || $scope.isSearchVisible) return;

        var input = $element.find('input');
        $scope.isSearchVisible = true;
        overflowHiddenService.toggle('body', $scope.isSearchVisible)

        // if (isMobile) input.attr('placeholder', 'Search');
        $timeout(function () {
          var tagsList = $element.find('.tags');
          tagsList.css('max-width', tagsList.width() - 1);
          input.focus();
          Ps.initialize(tagsList[0]);
        }, 300);
      };

      $scope.hideSearch = function () {
        $scope.isHiding = true;
        Ps.destroy($element.find('.tags')[0]);
        $scope.isSearchVisible = false;
        overflowHiddenService.toggle('body', $scope.isSearchVisible);
        $timeout(function () { $scope.isHiding = false; }, 50);
      };

      $scope.clearTags = function () {
        $scope.tags.splice(0, $scope.tags.length);
        $scope.onTagRemoved();
        if (!isMobile) $scope.hideSearch();
      };

      $scope.calcMaxWidth = function () {
        if ($scope.isSearchVisible) {
          var tagsList = $element.find('.tags');
          tagsList.css('max-width', tagsList.width() - 1);
        }
      };

      $scope.$watch('tags', function(newValue) {
        if (newValue) {
          $timeout(function () {
            var tags = $element.find('.tags');
            var tagInput = $element.find('.input');
            var tagsListWidth = $element.find('.tag-list').width();
            if (tagsListWidth > tags.width()) {
              tags[0].scrollLeft = tagsListWidth - tags.width() + tagInput.width() + 10;
              Ps.update(tags[0]);
            }
          });
        }
      }, true);

      $scope.$watch('reportType', function(newValue) {
        if (newValue) {
          $scope.tags.splice(0, $scope.tags.length);
          if (!isMobile) $scope.hideSearch();
        }
      }, true);
    }
  }]);
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/search/directive.js